import highlights from '@/mixins/search/highlights'

export default {
  mixins: [highlights],
  props: {
    highlights: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    index: {
      type: String,
      required: true
    },
    highlightsLoading: {
      type: Boolean,
      required: true
    },
    link: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
      descriptionPrefix: '<span class="t-500">Description: </span>'
    }
  },
  computed: {
    researchGroup () {
      return this.data.research_group
    },
    title () {
      return this.highlights && this.highlights.title ? this.highlights.title[0] : this.data.title
    },
    description () {
      if (!this.isEmpty(this.descriptionDescription)) {
        return (this.data.description) ? `${this.descriptionPrefix} ${this.descriptionDescription}` : ''
      }

      return (this.data.description) ? `${this.descriptionPrefix} ${this.stripTagsNoMark(this.data.description)}` : ''
    },
    owners () {
      return this.data.research_group.owners
    }
  }
}
